<template>
  <section class="main-banner">
    <b-container class="h-100">
      <b-row class="h-100 align-content-center">
        <b-col sm="12" md="6" lg="6" order="2" order-md="1">
          <div class="banner-container-content">
            <h1 class="banner-title" v-html="$t('news_feed')"></h1>
            <p class="banner-subtitle" v-html="$t('banner_subtitle_news_feed')"></p>
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="6" order="1" order-md="2">
          <div class="banner-img-container">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/news/news-banner-eng.png" alt="News banner image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/news/news-banner-eng.png" alt="News banner image">
            <img v-else class="main-photo" src="../../assets/img/news/news-banner-eng.png" alt="News banner image">
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/app";
.main-banner{
  display: flex;
  align-items: center;
  min-height: 500px;
  position: relative;
  gap: 24px;
  background: radial-gradient(56.79% 107.89% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  @media screen and (min-width: 768px) {
    min-height: unset;
  }
  @media screen and (min-width: 992px) {
    min-height: 305px;
  }
  @media screen and (min-width: 1440px) {
    @media screen and (min-width: 768px) {
      min-height: 500px;
    }
  }
  .banner-container-content{
    font-family: $main-font;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
    gap: 24px;
    @media screen and (min-width: 320px) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    @media screen and (min-width: 768px) {
      padding-top: 0;
      padding-bottom: 0;
    }
    .banner-title{
      letter-spacing: 0;
      margin: 0;
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
      text-align: left;
      @media screen and (min-width: 320px) {
        font-size: 32px;
        line-height: 120%;
      }
      @media screen and (min-width: 1440px) {
        font-size: 40px;
        line-height: 48px;
      }
    }
    .banner-subtitle{
      letter-spacing: 0;
      margin: 0;
      font-size: 20px;
      font-weight: 300;
      line-height: 28px;
      text-align: left;
      @media screen and (min-width: 320px) {
        font-size: 18px;
        line-height: 120%;
      }
      @media screen and (min-width: 1440px) {
        font-size: 20px;
        line-height: 28px;
      }

    }
  }
  .banner-img-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
      max-width: 580px;
      height: auto;
      @media screen and (min-width: 768px) {
        margin-top: 32px;
        margin-bottom: 40px;
      }
      @media screen and (min-width: 1440px) {
        width: auto;
        max-width: unset;
        margin-top: 0;
        margin-bottom: 0;
        position: relative;
        left: 35px;
      }

    }
  }
}
</style>
